"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = exports.defaultApiConfig = exports.defaultReadConfig = exports.questionSet = exports.guessTheAnswer = exports.attempted = exports.completed = exports.blackList = void 0;
exports.blackList = [
    "http://adlnet.gov/expapi/verbs/attended",
    "http://adlnet.gov/expapi/verbs/attempted",
    "http://adlnet.gov/expapi/verbs/interacted",
    "http://adlnet.gov/expapi/verbs/imported",
    "http://adlnet.gov/expapi/verbs/created",
];
exports.completed = [
    "http://adlnet.gov/expapi/verbs/completed",
    "http://adlnet.gov/expapi/verbs/answered",
    "http://activitystrea.ms/schema/1.0/consume",
    "http://adlnet.gov/expapi/verbs/passed",
    "http://adlnet.gov/expapi/verbs/mastered",
];
exports.attempted = "http://adlnet.gov/expapi/verbs/attempted";
exports.guessTheAnswer = "GuessTheAnswer";
exports.questionSet = "QuestionSet";
/** TODO this should be divide into each file and just imported here and merged into one object   */
exports.defaultReadConfig = {
    apiUrl: "",
    getImagePrefix: function () { return ""; },
    getImageSvgPrefix: function () { return ""; },
    courses: {
        loading: false,
    },
    fetchCourses: function () { return Promise.reject(); },
    userGroup: {
        loading: false,
    },
    fetchChallenges: function () { return Promise.reject(); },
    challenges: {
        loading: false,
    },
    fetchUserGroup: function () { return Promise.reject(); },
    userGroups: {
        loading: false,
    },
    fetchUserGroups: function () { return Promise.reject(); },
    registerableGroups: {
        loading: false,
    },
    fetchRegisterableGroups: function () { return Promise.reject(); },
    course: {
        loading: false,
    },
    fetchCourse: function (id) { return Promise.reject(); },
    program: {
        loading: false,
    },
    fetchProgram: function (id) { return Promise.reject(); },
    login: function (body) { return Promise.reject(); },
    logout: function () { return Promise.reject(); },
    settings: { loading: false, value: {} },
    fetchSettings: function () { return Promise.reject(); },
    config: {
        loading: false,
        value: {},
    },
    fetchConfig: function () { return Promise.reject(); },
    uniqueTags: {
        loading: false,
        list: [],
    },
    fetchTags: function () { return Promise.reject(); },
    categoryTree: {
        loading: false,
        list: [],
    },
    fetchCategories: function () { return Promise.reject(); },
    user: {
        loading: false,
    },
    register: function () {
        return Promise.reject({
            success: false,
            message: "register method not implemented",
        });
    },
    forgot: function (body) { return Promise.reject(); },
    reset: function (body) { return Promise.reject(); },
    emailVerify: function (id, hash) { return Promise.reject(); },
    initAccountDelete: function () { return Promise.reject(); },
    confirmAccountDelete: function () { return Promise.reject(); },
    addToCart: function (id, quantity) { return Promise.reject(); },
    addMissingProducts: function (products) { return Promise.reject(); },
    removeFromCart: function (id) { return Promise.reject(id); },
    fetchCart: function () { return Promise.reject(); },
    resetCart: function () { return Promise.reject(); },
    cart: {
        loading: false,
        value: {
            total: 0,
            subtotal: 0,
            tax: 0,
            items: [],
            coupon: null,
            total_with_tax: 0,
        },
    },
    payWithStripe: function (payment_method, return_url) {
        return Promise.reject(payment_method);
    },
    payWithP24: function (email, return_url, data) {
        return Promise.reject();
    },
    subscriptionPayWithP24: function (subId, email, return_url, data) { return Promise.reject(); },
    fetchProgress: function () { return Promise.reject(); },
    fetchPaginatedProgress: function () { return Promise.reject(); },
    paginatedProgress: {
        loading: false,
    },
    fetchMyAuthoredCourses: function () { return Promise.reject(); },
    fetchCourseProgress: function (id) { return Promise.reject(); },
    courseProgressDetails: {
        loading: false,
        byId: {},
    },
    progress: {
        loading: false,
        value: [],
    },
    myAuthoredCourses: {
        loading: false,
    },
    sendProgress: function (courseId, data) {
        return Promise.reject();
    },
    h5pProgress: function (courseId, topicId, statement) {
        return Promise.reject();
    },
    tutors: {
        loading: false,
        list: [],
    },
    fetchTutors: function () { return Promise.reject(); },
    tutor: {
        loading: false,
    },
    fetchTutor: function (id) { return Promise.reject(id); },
    orders: {
        loading: false,
    },
    fetchOrders: function (filter) { return Promise.reject(); },
    payments: {
        loading: false,
    },
    certificates: {
        loading: false,
    },
    fetchCertificates: function (params) { return Promise.reject(); },
    fetchCertificate: function (id) { return Promise.reject(id); },
    generateCertificate: function (id) { return Promise.reject(id); },
    getProductInfo: function (id) { return Promise.reject(id); },
    pages: {
        loading: false,
    },
    mattermostChannels: {
        loading: false,
        value: { server: "", teams: [] },
    },
    fetchMattermostChannels: function () { return Promise.reject(); },
    fetchPages: function () { return Promise.reject(); },
    page: {
        loading: false,
    },
    fetchPage: function (slug) { return Promise.reject(); },
    fetchPayments: function () { return Promise.reject(); },
    fetchProfile: function () { return Promise.reject(); },
    updateProfile: function (data) { return Promise.reject(data); },
    updateProfileEmail: function (data) { return Promise.reject(data); },
    updateAvatar: function (avatar) { return Promise.reject(avatar); },
    topicPing: function (topicId) { return Promise.reject(topicId); },
    topicIsFinished: function (topicId) { return false; },
    courseProgress: function (courseId) { return 0; },
    getNextPrevTopic: function (topicId, next) { return null; },
    socialAuthorize: function (token) { return Promise.reject(); },
    notifications: {
        loading: false,
    },
    fetchNotifications: function (params) { return Promise.reject(); },
    readAllNotifications: function () { return Promise.reject(); },
    readNotify: function (id) { return Promise.reject(); },
    h5p: {
        loading: false,
    },
    fetchH5P: function (id) { return Promise.reject(); },
    getRefreshedToken: function () { return Promise.reject(); },
    fetchConsultations: function () { return Promise.reject(); },
    fetchConsultation: function (id) { return Promise.reject(); },
    fetchUserConsultations: function () { return Promise.reject(); },
    consultation: {
        loading: false,
    },
    consultations: {
        loading: false,
    },
    userConsultations: {
        loading: false,
    },
    userWebinars: { loading: false },
    fetchUserWebinars: function () { return Promise.reject(); },
    fetchWebinar: function (id) { return Promise.reject(); },
    fetchProducts: function (filter) { return Promise.reject(); },
    fetchProduct: function (id) { return Promise.reject(); },
    fetchMyProducts: function (filter) { return Promise.reject(); },
    attachProduct: function (productableId, productableType) {
        return Promise.reject();
    },
    cancelSubscription: function (productId) { return Promise.reject(); },
    fields: {
        loading: false,
        list: [],
    },
    fetchFields: function (filter) { return Promise.reject(); },
    stationaryEvents: {
        loading: false,
    },
    stationaryEvent: {
        loading: false,
    },
    tutorConsultations: {
        loading: false,
    },
    fetchStationaryEvents: function (filter) {
        return Promise.reject();
    },
    fetchStationaryEvent: function (id) { return Promise.reject(); },
    bookConsultationTerm: function (id, term) { return Promise.reject(); },
    fetchWebinars: function (filter) { return Promise.reject(); },
    fetchTutorConsultations: function () { return Promise.reject(); },
    approveConsultationTerm: function (consultationTermId, term, userId) { return Promise.reject(); },
    rejectConsultationTerm: function (consultationTermId, term, userId) { return Promise.reject(); },
    generateConsultationJitsy: function (consultationTermId, term) {
        return Promise.reject(consultationTermId);
    },
    generateWebinarJitsy: function (webinarId) { return Promise.reject(webinarId); },
    webinars: {
        loading: false,
    },
    webinar: {
        loading: false,
    },
    events: { loading: false },
    fetchEvents: function (filter) { return Promise.reject(); },
    changePassword: function () { return Promise.reject(); },
    deleteAccount: function () { return Promise.reject(); },
    realizeVoucher: function () { return Promise.reject(); },
    removeVoucher: function () { return Promise.reject(); },
    createTeamsChat: function () { return Promise.reject(); },
    products: {
        loading: false,
    },
    userProducts: {
        loading: false,
    },
    product: {
        loading: false,
    },
    fetchQuestionnaires: function (model, id) { return Promise.reject(); },
    fetchQuestionnaire: function (modelTypeTitle, modelID, id) {
        return Promise.reject();
    },
    fetchQuestionnairesAnswers: function (modelTypeTitle, modelID, id, params) { return Promise.reject(); },
    fetchQuestionnaireStars: function (modelTypeTitle, modelID, id) { return Promise.reject(); },
    fetchQuestionnaireStarsByModel: function (modelTypeTitle, modelID) {
        return Promise.reject();
    },
    sendQuestionnaireAnswer: function (model, modelID, id, body) { return Promise.reject(); },
    fetchUserStationaryEvents: function () { return Promise.reject(); },
    userStationaryEvents: {
        loading: false,
    },
    fetchOrderInvoice: function (id) { return Promise.reject(id); },
    changeConsultationTerm: function (termId, newDate, term, userId) { return Promise.reject(); },
    tasks: {
        loading: false,
    },
    fetchTasks: function (filter) { return Promise.reject(); },
    courseAccess: {
        loading: false,
    },
    myCourses: {
        loading: false,
        value: [],
    },
    fetchMyCourses: function () { return Promise.reject(); },
    fetchCourseAccess: function (filter) {
        return Promise.reject();
    },
    addCourseAccess: function (data) {
        return Promise.reject();
    },
    deleteCourseAccess: function (id) { return Promise.reject(); },
    task: {
        loading: false,
    },
    challenge: {
        loading: false,
    },
    attendances: {
        loading: false,
    },
    consultationAccessEnquiry: {
        loading: false,
    },
    fetchConsultationAccessEnquiry: function (enquiryId) { return Promise.reject(); },
    consultationAccess: {
        loading: false,
    },
    fetchConsultationAccess: function (filter) {
        return Promise.reject();
    },
    addConsultationAccess: function (data) {
        return Promise.reject();
    },
    deleteConsultationAccess: function (id) { return Promise.reject(); },
    updateConsultationAccess: function (id, data) { return Promise.reject(); },
    fetchTask: function (id) { return Promise.reject(); },
    fetchChallenge: function (id) { return Promise.reject(); },
    fetchAttendances: function (groupId) { return Promise.reject(); },
    deleteTask: function (id) { return Promise.reject(); },
    addTask: function (data) {
        return Promise.reject();
    },
    updateTask: function (id, data) { return Promise.reject(); },
    updateTaskStatus: function (id, done) { return Promise.reject(id); },
    createTaskNote: function (id, note) { return Promise.reject(id); },
    updateTaskNote: function (id, taskNoteId, note) {
        return Promise.reject(id);
    },
    deleteTaskNote: function (taskNoteId) { return Promise.reject(taskNoteId); },
    schedule: {
        loading: false,
        list: [],
    },
    scheduleTutors: {
        loading: false,
        list: [],
    },
    fetchSchedule: function () { return Promise.reject(); },
    fetchScheduleTutors: function () { return Promise.reject(); },
    bookmarkNotes: {
        loading: false,
    },
    fetchBookmarkNotes: function (filter) { return Promise.reject(); },
    createBookmarkNote: function (body) { return Promise.reject(); },
    updateBookmarkNote: function (id, body) { return Promise.reject(id); },
    deleteBookmarkNote: function (id) { return Promise.reject(id); },
    subjects: {
        loading: false,
    },
    fetchExams: function (params) { return Promise.reject(); },
    exams: {
        loading: false,
    },
    fetchSubjects: function (params) { return Promise.reject(); },
    fetchSemesters: function (params) { return Promise.reject(); },
    semesters: {
        loading: false,
        list: [],
    },
    academicYears: {
        loading: false,
        list: [],
    },
    fetchAcademicYears: function (params) { return Promise.reject(); },
    dictionariesWords: {
        loading: false,
    },
    fetchDictionariesWords: function () { return Promise.reject(); },
    dictionariesWord: {
        loading: false,
    },
    fetchDictionariesWord: function () { return Promise.reject(); },
    dictionariesAccess: {
        loading: false,
    },
    fetchDictionariesAccess: function () { return Promise.reject(); },
    dictionariesWordsCategories: {
        loading: false,
        list: [],
    },
    fetchDictionariesWordsCategories: function () { return Promise.reject(); },
};
exports.defaultApiConfig = {
    apiUrl: "",
    myCourses: {
        loading: false,
        value: [],
    },
    fetchMyCourses: function () { return Promise.reject(); },
    getImagePrefix: function () { return ""; },
    getImageSvgPrefix: function () { return ""; },
    courses: {
        loading: false,
    },
    fetchCourses: function () { return Promise.reject(); },
    userGroup: {
        loading: false,
    },
    fetchChallenges: function () { return Promise.reject(); },
    challenges: {
        loading: false,
    },
    fetchUserGroup: function () { return Promise.reject(); },
    userGroups: {
        loading: false,
    },
    fetchUserGroups: function () { return Promise.reject(); },
    registerableGroups: {
        loading: false,
    },
    fetchRegisterableGroups: function () { return Promise.reject(); },
    course: {
        loading: false,
    },
    fetchCourse: function (id) { return Promise.reject(); },
    program: {
        loading: false,
    },
    fetchProgram: function (id) { return Promise.reject(); },
    login: function (body) { return Promise.reject(); },
    logout: function () { return Promise.reject(); },
    settings: {
        loading: false,
        value: [],
    },
    fetchSettings: function () { return Promise.reject(); },
    config: {
        loading: false,
        value: {
            escola_auth: {
                additional_fields: [],
                additional_fields_required: [],
            },
        },
    },
    fetchConfig: function () { return Promise.reject(); },
    uniqueTags: {
        loading: false,
        list: [],
    },
    fetchTags: function () { return Promise.reject(); },
    categoryTree: {
        loading: false,
        list: [],
    },
    fetchCategories: function () { return Promise.reject(); },
    user: {
        loading: false,
    },
    register: function () {
        return Promise.reject({
            success: false,
            message: "register method not implemented",
        });
    },
    forgot: function (body) { return Promise.reject(); },
    reset: function (body) { return Promise.reject(); },
    emailVerify: function (id, hash) { return Promise.reject(); },
    initAccountDelete: function () { return Promise.reject(); },
    confirmAccountDelete: function () { return Promise.reject(); },
    addToCart: function (id, quantity) { return Promise.reject(); },
    addMissingProducts: function (products) { return Promise.reject(); },
    removeFromCart: function (id) { return Promise.reject(id); },
    fetchCart: function () { return Promise.reject(); },
    resetCart: function () { return Promise.reject(); },
    cart: {
        loading: false,
        value: {
            total: 0,
            subtotal: 0,
            tax: 0,
            items: [],
            coupon: null,
            total_with_tax: 0,
        },
    },
    payWithStripe: function (payment_method, return_url) {
        return Promise.reject(payment_method);
    },
    payWithP24: function (email, return_url, data) {
        return Promise.reject();
    },
    subscriptionPayWithP24: function (subId, email, return_url, data) { return Promise.reject(); },
    fetchProgress: function () { return Promise.reject(); },
    fetchPaginatedProgress: function () { return Promise.reject(); },
    paginatedProgress: {
        loading: false,
    },
    fetchMyAuthoredCourses: function () { return Promise.reject(); },
    fetchCourseProgress: function (id) { return Promise.reject(); },
    courseProgressDetails: {
        loading: false,
        byId: {},
    },
    progress: {
        loading: false,
        value: [],
    },
    myAuthoredCourses: {
        loading: false,
    },
    sendProgress: function (courseId, data) {
        return Promise.reject();
    },
    h5pProgress: function (courseId, topicId, statement) {
        return Promise.reject();
    },
    tutors: {
        loading: false,
        list: [],
    },
    fetchTutors: function () { return Promise.reject(); },
    tutor: {
        loading: false,
    },
    fetchTutor: function (id) { return Promise.reject(id); },
    orders: {
        loading: false,
    },
    fetchOrders: function (filter) { return Promise.reject(); },
    payments: {
        loading: false,
    },
    certificates: {
        loading: false,
    },
    fetchCertificates: function (params) { return Promise.reject(); },
    fetchCertificate: function (id) { return Promise.reject(id); },
    generateCertificate: function (id) { return Promise.reject(id); },
    getProductInfo: function (id) { return Promise.reject(id); },
    pages: {
        loading: false,
    },
    mattermostChannels: {
        loading: false,
        value: { server: "", teams: [] },
    },
    fetchMattermostChannels: function () { return Promise.reject(); },
    fetchPages: function () { return Promise.reject(); },
    page: {
        loading: false,
    },
    fetchPage: function (slug) { return Promise.reject(); },
    fetchPayments: function () { return Promise.reject(); },
    fetchProfile: function () { return Promise.reject(); },
    updateProfile: function (data) { return Promise.reject(data); },
    updateProfileEmail: function (data) { return Promise.reject(data); },
    updateAvatar: function (avatar) { return Promise.reject(avatar); },
    topicPing: function (topicId) { return Promise.reject(topicId); },
    topicIsFinished: function (topicId) { return false; },
    courseProgress: function (courseId) { return 0; },
    getNextPrevTopic: function (topicId, next) { return null; },
    getRefreshedToken: function () { return Promise.reject(); },
    socialAuthorize: function (token) { return Promise.reject(); },
    notifications: {
        loading: false,
    },
    fetchNotifications: function (params) { return Promise.reject(); },
    readNotify: function (id) { return Promise.reject(); },
    readAllNotifications: function () { return Promise.reject(); },
    h5p: {
        loading: false,
    },
    fetchH5P: function (uuid) { return Promise.reject(); },
    fetchConsultations: function () { return Promise.reject(); },
    fetchConsultation: function (id) { return Promise.reject(); },
    fetchUserConsultations: function () { return Promise.reject(); },
    consultation: {
        loading: false,
    },
    consultations: {
        loading: false,
    },
    fields: {
        loading: false,
        list: [],
    },
    userConsultations: {
        loading: false,
    },
    tutorConsultations: {
        loading: false,
    },
    userWebinars: { loading: false },
    fetchUserWebinars: function () { return Promise.reject(); },
    fetchWebinar: function (id) { return Promise.reject(); },
    fetchProducts: function (filter) { return Promise.reject(); },
    fetchMyProducts: function (filter) { return Promise.reject(); },
    fetchProduct: function (id) { return Promise.reject(); },
    attachProduct: function (productableId, productableType) {
        return Promise.reject();
    },
    cancelSubscription: function (productId) { return Promise.reject(); },
    fetchFields: function (filter) { return Promise.reject(); },
    stationaryEvents: {
        loading: false,
    },
    stationaryEvent: {
        loading: false,
    },
    fetchStationaryEvents: function (filter) {
        return Promise.reject();
    },
    fetchStationaryEvent: function (id) { return Promise.reject(); },
    bookConsultationTerm: function (id, term) { return Promise.reject(); },
    fetchWebinars: function (filter) { return Promise.reject(); },
    webinars: { loading: false },
    webinar: {
        loading: false,
    },
    fetchTutorConsultations: function () { return Promise.reject(); },
    approveConsultationTerm: function (consultationTermId, term, userId) { return Promise.reject(); },
    rejectConsultationTerm: function (consultationTermId, term, userId) { return Promise.reject(); },
    generateConsultationJitsy: function (consultationTermId, term) {
        return Promise.reject(consultationTermId);
    },
    generateWebinarJitsy: function (webinarId) { return Promise.reject(webinarId); },
    events: {
        loading: false,
    },
    fetchEvents: function (filter) { return Promise.reject(); },
    changePassword: function () { return Promise.reject(); },
    deleteAccount: function () { return Promise.reject(); },
    realizeVoucher: function () { return Promise.reject(); },
    removeVoucher: function () { return Promise.reject(); },
    createTeamsChat: function () { return Promise.reject(); },
    products: {
        loading: false,
    },
    userProducts: {
        loading: false,
    },
    product: {
        loading: false,
    },
    fetchQuestionnaires: function (model, id) { return Promise.reject(); },
    fetchQuestionnaire: function (modelTypeTitle, modelID, id) {
        return Promise.reject();
    },
    fetchQuestionnairesAnswers: function (modelTypeTitle, modelID, id, params) { return Promise.reject(); },
    sendQuestionnaireAnswer: function (model, modelID, id, body) { return Promise.reject(); },
    fetchQuestionnaireStars: function (modelTypeTitle, modelID, id) { return Promise.reject(); },
    fetchQuestionnaireStarsByModel: function (modelTypeTitle, modelID) {
        return Promise.reject();
    },
    fetchUserStationaryEvents: function () { return Promise.reject(); },
    userStationaryEvents: {
        loading: false,
    },
    fetchOrderInvoice: function (id) { return Promise.reject(id); },
    changeConsultationTerm: function (termId, newDate, term, userId) { return Promise.reject(); },
    tasks: {
        loading: false,
    },
    fetchTasks: function (filter) { return Promise.reject(); },
    courseAccess: {
        loading: false,
    },
    fetchCourseAccess: function (filter) {
        return Promise.reject();
    },
    deleteCourseAccess: function (id) { return Promise.reject(); },
    addCourseAccess: function (data) {
        return Promise.reject();
    },
    consultationAccessEnquiry: { loading: false },
    fetchConsultationAccessEnquiry: function (enquiryId) { return Promise.reject(); },
    consultationAccess: {
        loading: false,
    },
    fetchConsultationAccess: function (filter) {
        return Promise.reject();
    },
    deleteConsultationAccess: function (id) { return Promise.reject(); },
    addConsultationAccess: function (data) {
        return Promise.reject();
    },
    updateConsultationAccess: function (id, data) { return Promise.reject(); },
    task: {
        loading: false,
    },
    challenge: {
        loading: false,
    },
    attendances: {
        loading: false,
    },
    fetchTask: function (id) { return Promise.reject(id); },
    fetchChallenge: function (id) { return Promise.reject(id); },
    fetchAttendances: function (groupId) { return Promise.reject(groupId); },
    deleteTask: function (id) { return Promise.reject(); },
    addTask: function (data) {
        return Promise.reject();
    },
    updateTask: function (id, data) { return Promise.reject(id); },
    updateTaskStatus: function (id, done) { return Promise.reject(id); },
    createTaskNote: function (id, note) { return Promise.reject(id); },
    updateTaskNote: function (id, taskNoteId, note) {
        return Promise.reject(id);
    },
    deleteTaskNote: function (taskNoteId) { return Promise.reject(taskNoteId); },
    schedule: {
        loading: false,
        list: [],
    },
    scheduleTutors: {
        loading: false,
        list: [],
    },
    fetchSchedule: function () { return Promise.reject(); },
    fetchScheduleTutors: function () { return Promise.reject(); },
    bookmarkNotes: {
        loading: false,
    },
    fetchBookmarkNotes: function (filter) { return Promise.reject(); },
    createBookmarkNote: function (body) { return Promise.reject(); },
    updateBookmarkNote: function (id, body) { return Promise.reject(id); },
    deleteBookmarkNote: function (id) { return Promise.reject(id); },
    subjects: {
        loading: false,
    },
    fetchSubjects: function () { return Promise.reject(); },
    fetchExams: function () { return Promise.reject(); },
    exams: {
        loading: false,
    },
    fetchSemesters: function () { return Promise.reject(); },
    semesters: {
        loading: false,
        list: [],
    },
    fetchAcademicYears: function () { return Promise.reject(); },
    academicYears: {
        loading: false,
        list: [],
    },
    dictionariesWords: {
        loading: false,
    },
    fetchDictionariesWords: function () { return Promise.reject(); },
    dictionariesWord: {
        loading: false,
    },
    fetchDictionariesWord: function () { return Promise.reject(); },
    dictionariesAccess: {
        loading: false,
    },
    fetchDictionariesAccess: function () { return Promise.reject(); },
    dictionariesWordsCategories: {
        loading: false,
        list: [],
    },
    fetchDictionariesWordsCategories: function () { return Promise.reject(); },
};
exports.defaultConfig = Object.assign({}, exports.defaultReadConfig, exports.defaultApiConfig);
